import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';
import { ISeance } from '../../types/seance';

function getSeances(params: any): AxiosPromise<ISeance[]> {
    return EndPointService.get('/seances', { params });
}
function updateSeanceNote(id: any, params: any): AxiosPromise {
    return EndPointService.put(`/seances/notes/${id}`, { ...params });
}
function updateSeanceInTime(id: any, params: any): AxiosPromise {
    return EndPointService.put(`/seances/in-time/${id}`, { ...params });
}

function getunconfirmedSeance(params: any): AxiosPromise {
    return EndPointService.get('/seances/unconfirmed', { params });
}

function getSeance(id: number | string): AxiosPromise {
    return EndPointService.get(`/seances/${id}`);
}

function deleteSeance(id: number | string): AxiosPromise {
    return EndPointService.delete(`/seances/${id}`);
}

function createSeance(payload: any): AxiosPromise {
    return EndPointService.post('/seances', payload);
}

function deleteFileSeance(fileId: number | string): AxiosPromise {
    return EndPointService.delete(`/seance_docs/${fileId}`);
}

function createFilesSeance(data: any): AxiosPromise {
    return EndPointService.post(`/seance_docs`, data);
}

function getFilesSeance(id: string | number): AxiosPromise {
    return EndPointService.get(`/seance_docs`, {
        params: {
            'seance.id': id,
        },
    });
}

function signSeance(id: string | number): AxiosPromise {
    return EndPointService.put(`/seances/sign/${id}`);
}

function moveToOccasionSeance(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/seances/move/${id}`, { ...payload });
}

function updateSeance(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/seances/${id}`, { ...payload });
}

function getSeancesStatistics(params: any): AxiosPromise {
    return EndPointService.get('/seances/statistics', {
        params,
    });
}

export default {
    getSeances,
    getSeancesStatistics,
    getFilesSeance,
    createFilesSeance,
    deleteFileSeance,
    getSeance,
    deleteSeance,
    createSeance,
    signSeance,
    updateSeance,
    getunconfirmedSeance,
    updateSeanceNote,
    moveToOccasionSeance,
    updateSeanceInTime,
};
